import Button, { ButtonType } from '@/components/Button';
import DictTable from '@/components/DictTable';
import { AssetInfo } from '@/lib/Asset/types';
import Analytics from '@/system/Analytics';
import { IndividualAssetEvents } from '@/system/Analytics/events/IndividualAssetEvents';
import LocationUtils from '@/utils/LocationUtils';
import clsx from 'clsx';
import React, { useMemo, useState } from 'react';
import { twMerge } from 'tailwind-merge';

export interface IAboutProps {
  assetInfo: AssetInfo;
  className?: string;
}

function About({ assetInfo, className }: IAboutProps) {
  const [clampAboutText, setClampAboutText] = useState(true);

  const tableData = useMemo(() => {
    return [
      [
        {
          key: 'Industry',
          value: assetInfo?.extra_data?.industry || '--',
        },
        /*{
          key: 'Headquarters',
          value:
            assetInfo?.extra_data?.city && assetInfo?.extra_data?.state
              ? `${assetInfo?.extra_data?.city}, ${LocationUtils.abbrRegion(String(assetInfo?.extra_data?.state), 'abbr')}`
              : '--',
        },*/
      ],
      [
        {
          key: 'Employees',
          value: assetInfo?.extra_data?.employees || '--',
        },
      ],
    ];
  }, [assetInfo]);

  const clickShowMoreOrLess = async () => {
    Analytics.track(IndividualAssetEvents.CLICKED_SHOW_MORE_OR_LESS, {
      type: clampAboutText ? 'more' : 'less',
    });
    setClampAboutText(!clampAboutText);
  };

  return (
    <div className={twMerge(clsx("rounded-2xl bg-darkglass p-6", className))}>
      <h4 className="mb-2 text-secondary">About</h4>
      <div>
        <p className={clsx('mt-2 text-base', { 'line-clamp': clampAboutText })}>
          {assetInfo.description || ''}
        </p>
        <Button type={ButtonType.Link} className="mt-4 font-semibold" onClick={clickShowMoreOrLess}>
          Show {clampAboutText ? 'more +' : 'less -'}
        </Button>
      </div>
      <div className="flex mt-4">
        <DictTable columns={tableData} />
      </div>
    </div>
  );
}

export default About;
